import { motion, AnimatePresence } from 'framer-motion';
import FileListItem from './FileListItem';
import type { FileSetter } from '../types';

interface FileQueuePanelProps {
  files: File[];
  setFiles: FileSetter;
  isConverting: boolean;
}

const FileQueuePanel = ({ files, setFiles, isConverting }: FileQueuePanelProps) => {
  const removeFile = (index: number) =>
    setFiles((prev) => prev.filter((_, i) => i !== index));

  return (
    <div className="glass rounded-3xl p-5 md:p-6 shadow-xl">
      <h3 className="text-sm font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-4">
        Queue · {files.length} file{files.length > 1 ? 's' : ''}
      </h3>
      <div className="max-h-[340px] overflow-y-auto space-y-2 pr-1">
        <AnimatePresence initial={false}>
          {files.map((file, idx) => (
            <motion.div
              key={`${file.name}-${file.size}`}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
            >
              <FileListItem
                file={file}
                onRemove={isConverting ? null : () => removeFile(idx)}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FileQueuePanel;
